import React from "react";

export const IconArrowDown = (props) => {
    const { className, strokeWidth, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            {...otherProps}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth ?? 1}
                d="M19 9l-7 7-7-7"
            />
        </svg>
    );
};

export const IconArrowUp = (props) => {
    const { className, strokeWidth, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            {...otherProps}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth ?? 1}
                d="M5 15l7-7 7 7"
            />
        </svg>
    );
};

export const IconArrowLeft = (props) => {
    const { className, strokeWidth, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            {...otherProps}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M15 19l-7-7 7-7"
            />
        </svg>
    );
};

export const IconArrowRight = ({ className, strokeWidth, ...otherProps }) => {
    const classes = `h-6 w-6 ${className ?? ""}`.trim();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={classes}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            {...otherProps}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M9 18L15 12L9 6"
            />
        </svg>
    );
};

export const IconInfoPrimary = (props) => {
    const { className, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`;
    return (
        <svg
            className={css}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...otherProps}
        >
            <circle cx="11" cy="11" r="10.5" fill="#018DDF" stroke="#006FAD" />
            <path
                d="M11.25 7.5C11.9404 7.5 12.5 6.94036 12.5 6.25C12.5 5.55964 11.9404 5 11.25 5C10.5596 5 10 5.55964 10 6.25C10 6.94036 10.5596 7.5 11.25 7.5Z"
                fill="white"
            />
            <path
                d="M12 9L9.2 9V10.5H10.5V15H9V16.5H13.5V15L12 15V9Z"
                fill="white"
            />
        </svg>
    );
};

export const IconInfo = (props) => {
    const { className, strokeWidth, fill, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`;
    return (
        <svg
            className={css}
            viewBox="0 0 14 14"
            fill={fill ?? "none"}
            xmlns="http://www.w3.org/2000/svg"
            {...otherProps}
        >
            <path
                d="M7 0.7C8.67086 0.7 10.2733 1.36374 11.4548 2.54522C12.6363 3.7267 13.3 5.32914 13.3 7C13.3 8.67086 12.6363 10.2733 11.4548 11.4548C10.2733 12.6362 8.67086 13.3 7 13.3C5.32914 13.3 3.72671 12.6362 2.54523 11.4548C1.36375 10.2733 0.7 8.67086 0.7 7C0.7 5.32914 1.36375 3.7267 2.54523 2.54522C3.72671 1.36374 5.32914 0.7 7 0.7V0.7ZM7 0C5.14348 0 3.36301 0.737493 2.05025 2.05025C0.737498 3.363 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.363 11.9497 2.05025C10.637 0.737493 8.85652 0 7 0Z"
                fill="currentColor"
            />
            <path
                d="M6.9998 2.7998C6.81415 2.7998 6.63611 2.87355 6.50483 3.00483C6.37355 3.1361 6.2998 3.31415 6.2998 3.4998C6.2998 3.68546 6.37355 3.8635 6.50483 3.99478C6.63611 4.12606 6.81415 4.1998 6.9998 4.1998C7.18546 4.1998 7.3635 4.12606 7.49478 3.99478C7.62605 3.8635 7.6998 3.68546 7.6998 3.4998C7.6998 3.31415 7.62605 3.1361 7.49478 3.00483C7.3635 2.87355 7.18546 2.7998 6.9998 2.7998Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.6501 6.28594H5.6001V5.58594H7.3501V10.1499H6.6501V6.28594Z"
                fill="currentColor"
            />
            <path
                d="M5.42822 10.1504H8.57822"
                stroke="currentColor"
                strokeWidth={strokeWidth ?? "0.7"}
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export const IconWarningTriangle = (props) => {
    const { className, strokeWidth, stroke, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            fill="none"
            viewBox="0 0 24 24"
            stroke={stroke}
            {...otherProps}
        >
            <path
                d="M12.0394 3C11.6394 3 11.3394 3.2 11.0394 3.6L2.1394 19.4C1.7394 20.1 2.2394 21 3.1394 21H20.9394C21.7394 21 22.3394 20.1 21.9394 19.4L13.0394 3.6C12.7394 3.2 12.4394 3 12.0394 3ZM3.1394 20C3.1394 20 3.0394 20 3.1394 20C3.0394 19.9 3.0394 19.9 3.0394 19.9L11.9394 4C11.9394 4 11.9394 4 12.0394 4C12.1394 4 12.1394 4 12.1394 4L21.0394 19.9C21.0394 19.9 21.0394 19.9 21.0394 20H20.9394H3.1394Z"
                fill="#808080"
            />
            <path d="M12.5394 17H11.5394V18H12.5394V17Z" fill="#808080" />
            <path
                d="M12.5394 10H11.5394V15.5C11.5394 15.8 11.7394 16 12.0394 16C12.3394 16 12.5394 15.8 12.5394 15.5V10Z"
                fill="#808080"
            />
        </svg>
    );
};

export const IconWarningCircle = (props) => {
    const { className, strokeWidth, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            {...otherProps}
        >
            <g clipPath="url(#clip0_1344_21874)">
                <path
                    d="M12.5 14.9805H11.5V15.9805H12.5V14.9805Z"
                    fill="#808080"
                />
                <path
                    d="M11.5 13.48C11.5 13.6126 11.5527 13.7398 11.6464 13.8336C11.7402 13.9273 11.8674 13.98 12 13.98C12.1326 13.98 12.2598 13.9273 12.3536 13.8336C12.4473 13.7398 12.5 13.6126 12.5 13.48V8H11.5V13.48Z"
                    fill="#808080"
                />
                <path
                    d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51808 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2V2ZM12 21C10.22 21 8.47991 20.4722 6.99987 19.4832C5.51983 18.4943 4.36627 17.0887 3.68508 15.4442C3.0039 13.7996 2.82567 11.99 3.17293 10.2442C3.5202 8.49836 4.37737 6.89471 5.63604 5.63604C6.89471 4.37737 8.49836 3.5202 10.2442 3.17293C11.99 2.82567 13.7996 3.0039 15.4442 3.68508C17.0887 4.36627 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21Z"
                    fill="#808080"
                />
            </g>
        </svg>
    );
};

export const IconCircleCheck = (props) => {
    const { className, strokeWidth, filled, accentColour, ...otherProps } =
        props;
    var size = Number(props.size || 6);
    const css = `h-${size} w-${size} ${className ?? ""}`.trim();
    const detailColour = Boolean(filled)
        ? accentColour || "#fff"
        : "currentColor";

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            {...otherProps}
        >
            <circle
                cx="12"
                cy="12"
                r="10"
                strokeWidth="2"
                stroke="currentColor"
                fill={Boolean(filled) ? "currentColor" : "none"}
            />
            <path
                d="M9.89999 14.2996L7.59999 11.8996L6.89999 12.5996L9.89999 15.6996L16.9 8.89961L16.1 8.09961L9.89999 14.2996Z"
                stroke={detailColour}
                fill={detailColour}
            />
        </svg>
    );
};

export const IconEmail = (props) => {
    const { className, ...otherProps } = props;
    const css = `h-8 w-8 ${className ?? ""}`.trim();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            viewBox="0 0 20 20"
            width="288"
            height="288"
            {...otherProps}
        >
            <path
                d="M17.8 4H2.2C1.6 4 1 4.6 1 5.2v9.5c0 .7.6 1.3 1.2 1.3h15.5c.7 0 1.2-.6 1.2-1.2V5.2c.1-.6-.5-1.2-1.1-1.2zm-1 1L10 11.8 3.2 5h13.6zm1.2 9.8c0 .1-.1.3-.3.3H2.2c-.1-.1-.2-.2-.2-.3V5.2l8 8 8-8v9.6z"
                fill="currentColor"
            />
        </svg>
    );
};

export const IconLocation = (props) => {
    const { className, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`.trim();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            viewBox="0 0 20 20"
            stroke="currentColor"
            strokeWidth="0.5"
            fill="currentColor"
            {...otherProps}
        >
            <path
                className="st0"
                d="M10,0C6.1,0,2,2.8,2,7.9c0,5,8,12.1,8,12.1s8-7.1,8-12.1C18,2.8,13.8,0,10,0z M10,18.6c-2.4-2.3-7-7.3-7-10.7 C3,3.6,6.5,1,10,1s7,2.6,7,6.9C16.9,11.3,12.4,16.3,10,18.6z"
            />
            <path
                className="st0"
                d="M9.8,4c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3S11.5,4,9.8,4z M9.8,9c-1.1,0-2-0.9-2-2s0.9-2,2-2 c1.1,0,2,0.9,2,2S10.9,9,9.8,9z"
            />
        </svg>
    );
};

export const IconCross = (props) => {
    const { className, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`.trim();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            viewBox="0 0 20 20"
            stroke="currentColor"
            strokeWidth="0.5"
            fill="currentColor"
            {...otherProps}
        >
            <polygon
                className="st0"
                points="16.4,4.5 15.6,3.8 10,9.4 4.4,3.8 3.6,4.5 9.3,10.1 3.6,15.8 4.4,16.5 10,10.8 15.6,16.5 16.4,15.8 10.7,10.1 "
            />
        </svg>
    );
};

export const IconLock = (props) => {
    const { className, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`.trim();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            viewBox="0 0 20 20"
            stroke="currentColor"
            strokeWidth="0.5"
            fill="currentColor"
            {...otherProps}
        >
            <g>
                <path
                    className="st0"
                    d="M16.9,9H16V6c0-3.3-2.7-6-6-6S4,2.7,4,6v3H3.1C2.5,9,2,9.4,2,10v9c0,0.6,0.5,1,1.1,1h13.9c0.6,0,1.1-0.4,1.1-1 v-9C18,9.4,17.5,9,16.9,9z M5,6c0-2.8,2.2-5,5-5s5,2.2,5,5v3h-2V6c0-1.7-1.3-3-3-3S7,4.3,7,6v3H5V6z M12,9H8V6c0-1.1,0.9-2,2-2 s2,0.9,2,2V9z M16.9,19H3.1C3,19,3,19,3,19c0,0,0,0,0,0l0-9c0,0,0,0,0.1,0H4h3h6h3h0.9c0,0,0.1,0,0.1,0c0,0,0,0,0,0L16.9,19 C17,19,17,19,16.9,19z"
                />
                <path
                    className="st0"
                    d="M9.9,11.6c-0.9,0-1.6,0.7-1.6,1.6c0,0.7,0.5,1.3,1.1,1.5V17h1v-2.4c0.6-0.2,1.1-0.8,1.1-1.5 C11.5,12.3,10.8,11.6,9.9,11.6z M9.9,13.7c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6S10.2,13.7,9.9,13.7z"
                />
            </g>
        </svg>
    );
};

export const IconTick = (props) => {
    const { className, strokeWidth, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`.trim();
    const sWidth = strokeWidth ?? "2";
    return (
        <svg
            className={css}
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...otherProps}
        >
            <path
                d="M0.875977 6.39202L4.91248 10.499L14.751 0.749023"
                stroke="currentColor"
                strokeWidth={sWidth}
            />
        </svg>
    );
};

export const IconTickSolid = (props) => {
    const { className, ...otherProps } = props;
    const css = `h-6 w-6 ${className ?? ""}`.trim();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={css}
            viewBox="0 0 20 20"
            fill="currentColor"
            {...otherProps}
        >
            <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const IconSpinner = ({ className }) => (
    <svg
        className={`animate-spin ${className}`}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.9551 48C37.2347 48 48 37.2347 48 23.9551C48 11.4118 38.3954 1.1117 26.1393 0.00812011C24.937 -0.100143 23.9551 0.888881 23.9551 2.09608C23.9551 3.30328 24.9375 4.26916 26.1374 4.40159C35.9755 5.48739 43.6281 13.8275 43.6281 23.955C43.6281 34.8201 34.8201 43.6281 23.955 43.6281C13.8275 43.6281 5.48739 35.9755 4.40159 26.1374C4.26916 24.9375 3.30328 23.9551 2.09608 23.9551C0.888882 23.9551 -0.100143 24.937 0.00812009 26.1393C1.1117 38.3954 11.4118 48 23.9551 48Z"
            fill="currentColor"
        />
    </svg>
);

export const IconSearch = ({ className }) => (
    <svg
        className={`w-5 h-5 ${className}`}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_2125_20909)">
            <path
                d="M19.5 16.7L15.4 12.6C16.2 11.3 16.6 9.9 16.6 8.3C16.6 3.7 12.9 0 8.3 0C3.7 0 0 3.7 0 8.3C0 12.9 3.7 16.6 8.3 16.6C9.9 16.6 11.4 16.1 12.6 15.4L16.7 19.5C17 19.8 17.5 20 17.9 20C18.3 20 18.8 19.8 19.1 19.5L19.5 19.1C20.2 18.4 20.2 17.4 19.5 16.7ZM1 8.3C1 4.3 4.3 1 8.3 1C12.3 1 15.6 4.3 15.6 8.3C15.6 12.3 12.3 15.6 8.3 15.6C4.3 15.7 1 12.4 1 8.3ZM18.8 18.4L18.4 18.8C18.3 18.9 18.1 19 17.9 19C17.7 19 17.6 18.9 17.4 18.8L13.5 14.9C14 14.5 14.5 14 14.9 13.5L18.8 17.4C19.1 17.7 19.1 18.1 18.8 18.4Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_2125_20909">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
